import * as React from 'react';
import { connect } from 'react-redux';
import { withSiteData } from 'react-static';

import DateComponent from '../../components/Date/Date';
import { RootState } from '../../RootState';
import { Language } from '../Localization/localizationDuck';
import { SiteProps } from '../../SiteProps';

interface DateProps extends SiteProps {
  language: Language;
  value: Date;
}

const Date: React.SFC<DateProps> = ({ value, language, dateLocale }) => (
  <DateComponent value={value} locale={dateLocale[language]} />
);

const mapStateToProps = (state: RootState) => ({
  language: state.localization.language,
});

export default withSiteData(connect(mapStateToProps)(Date));



// WEBPACK FOOTER //
// /www/client/src/containers/Date/Date.tsx